<template>
  <div class="c-field-mapping-container">
    <div class="c-field-mapping-name">
      <span class="text-neutral-text-strong">
        {{ label }}
      </span>
      <BittsTag
        v-if="isRequired || isRecommended"
        :text="capitalize(level)"
        size="x-small"
        :color="level === 'required' ? 'info' : 'neutral'"
      />
    </div>
    <div class="c-field-mapping-select">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { BittsTag } from '@crossbeam/bitts';

import { capitalize } from 'humanize-plus';
import { computed } from 'vue';

type Props = {
  label: string;
  level: 'required' | 'recommended' | 'optional';
};

const { label, level } = defineProps<Props>();

const isRequired = computed(() => level === 'required');
const isRecommended = computed(() => level === 'recommended');
</script>
<style lang="pcss" scoped>
@reference "../../css/theme.css";
.c-field-mapping-container {
  @apply flex w-full border-t border-neutral-border;
  .c-field-mapping-name {
    @apply flex items-center gap-8 w-1/2 py-10 px-16;
  }
  .c-field-mapping-select {
    @apply flex-1 py-12 px-16;
  }
}
</style>
